import { createContext, useContext } from "react";

/**
 * deferred: waits until the surrounding application permits interruption.
 * foreground: covers ordinary application surfaces as part of the active workflow.
 * critical: supersedes every application surface.
 */
export type DialogPriority = "deferred" | "foreground" | "critical";

const DialogDeferralContext = createContext(false);

export const DialogDeferralProvider = DialogDeferralContext.Provider;

export const useDialogPresentation = (open: boolean, priority: DialogPriority) => {
  const hasActiveMobileOverlay = useContext(DialogDeferralContext);

  return {
    // Preserve each dialog's existing elevation unless it needs to cross the
    // overlay boundary on mobile. Critical dialogs always sit on top.
    className:
      priority === "critical"
        ? "z-[10001]"
        : priority === "foreground" && hasActiveMobileOverlay
          ? "z-[101]"
          : undefined,
    open: open && (priority !== "deferred" || !hasActiveMobileOverlay),
  };
};
